export const AssessmentType = {
    UNDEFINED: 0,
    CODERBYTE: 1,
    EVALUATION: 2,
    HACKEREARTH: 3,
    ADAPTIVE: 4,
    IMOCHA: 9,
    METTL: 10
};
